export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/graphics_for_streamers.9fc9b4d.svg";